/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';

import { StylesProvider } from '@material-ui/core/styles';
import MaterialTabs from '@material-ui/core/Tabs';
import cn from 'classnames';

import styles from './DeltaUnderlineTabs.module.scss';
import type { UnderlineTabsProps } from './DeltaUnderlineTabs.types';

/**
 * @description Just a wrapper component over Material UI tabs, for providing default styles.
 * It supports all the props accepted by Material UI Tabs.
 *
 * @see [Tabs](https://v4.mui.com/components/tabs/)
 * @see [Tabs API](https://v4.mui.com/api/tabs/)
 */
const UnderlineTabs = forwardRef((props: UnderlineTabsProps, ref) => {
  const { classes = {}, className, TabIndicatorProps = {}, ...restProps } = props;
  const { className: tabIndicatorClassName, ...restTabIndicatorProps } =
    TabIndicatorProps;
  const { flexContainer: flexContainerClass, ...restClasses } = classes;

  return (
    <StylesProvider injectFirst>
      <MaterialTabs
        TabIndicatorProps={{
          className: cn(styles.indicator, tabIndicatorClassName),
          ...restTabIndicatorProps,
        }}
        classes={{
          flexContainer: cn(styles.flexContainer, flexContainerClass),
          ...restClasses,
        }}
        innerRef={ref}
        className={cn(styles.underlineTabs, className)}
        {...restProps}
      />
    </StylesProvider>
  );
});

export { UnderlineTabs };
